import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class UserQueryService {

    public GET_USER_DETAIL_BY_USERID_DATA: any;


    constructor(public apollo: Apollo) {

        this.GET_USER_DETAIL_BY_USERID_DATA =
            gql`
        query GET_USER($userId:UUID!){

            allUsers(condition:{userId:$userId}) {
                edges {
                    node {               
                        firstName
                        lastName
                        email             
                    }
                }
                }

            }
        `
            ;

    }

    // Get rating of this order
    GET_USER_DETAIL_BY_USERID(userId) {
        console.log('userId', userId);
        return this.apollo
            .watchQuery({
                query: this.GET_USER_DETAIL_BY_USERID_DATA
                ,
                variables:
                {
                    'userId': userId,
                },
                fetchPolicy: 'network-only'
            });

    }
}


// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/clientdash/src/app/main/content/gql-query-mutation/users.ts